export default function initPasswordToggle() {
    const themeUri = (window.cbdonnaData && window.cbdonnaData.themeUri) || '';
    const eyeImg = themeUri + 'assets/images/icons/icon-eye.jpg';

    document.querySelectorAll('input[type="password"]').forEach(input => {
        if (input.closest('.cbdonna-password-toggle-wrap')) {
            return;
        }

        const wrapper = input.closest('.cbdonna-input-wrap') || input.parentElement;
        wrapper.classList.add('cbdonna-password-toggle-wrap');

        const btn = document.createElement('button');
        btn.className = 'cbdonna-password-toggle';
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Passwort anzeigen');
        btn.innerHTML = `<img src="${eyeImg}" alt="" width="20">`;

        btn.addEventListener('click', () => {
            const isPassword = input.type === 'password';
            input.type = isPassword ? 'text' : 'password';
            btn.setAttribute('aria-label', isPassword ? 'Passwort verstecken' : 'Passwort anzeigen');
            btn.classList.toggle('is-closed', isPassword);
        });

        wrapper.appendChild(btn);
    });
}
